import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { imgDetailModalRecoil } from '@/atom/ModalAtom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';
import ModalType1 from '@/modal/ModalType1';
import AddressModal from './AddressModal';

interface ImgModalProps {
  fileUrl: string;
}

const ImgModal = ({ fileUrl }: ImgModalProps) => {
  const [imgDetailModalState, setImgDetailModalState] =
    useRecoilState(imgDetailModalRecoil);

  return (
    <>
      <CS.ModalBg>
        <XBtn className="img-box" onClick={() => setImgDetailModalState(false)}>
          <img src="/img/ico_x_fff.svg" alt="" />
        </XBtn>
        <ImgBox className="img-box">
          <img src={fileUrl} alt="" />
        </ImgBox>
      </CS.ModalBg>
    </>
  );
};

export default ImgModal;

export const XBtn = styled.button`
  width: 24px;
  position: absolute;
  top: 24px;
  right: 24px;
`;

export const ImgBox = styled.div`
  width: 800px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
